import { supabase } from '../lib/supabase';

export const fetchBookings = async (limit = 200) => {
  const { data, error } = await supabase
    .from('bookings').select('*')
    .eq('archived', false)
    .order('booking_date', { ascending: true }).limit(limit);
  if (error) throw error;
  return data || [];
};

export const fetchBookingPhotos = async (bookingId) => {
  const { data } = await supabase.from('booking_photos').select('*').eq('booking_id', bookingId);
  if (!data || data.length === 0) return [];
  return Promise.all(data.map(async (p) => {
    // private bucket → createSignedUrl (1h expiry) instead of getPublicUrl
    const { data: urlData } = await supabase.storage
      .from('booking-photos')
      .createSignedUrl(p.storage_path, 3600);
    return { ...p, url: urlData?.signedUrl ?? null };
  }));
};

export const insertManualBooking = async (payload) => {
  const { data, error } = await supabase.from('bookings').insert([payload]).select().single();
  if (error) throw error;
  return data;
};

export const updateBooking = async (id, updates) => {
  const { error } = await supabase.from('bookings').update(updates).eq('id', id);
  if (error) throw error;
};

export const deleteBooking = async (id) => {
  const { error } = await supabase.from('bookings').delete().eq('id', id);
  if (error) throw error;
};

export const archiveBooking = async (id) => {
  const { error } = await supabase.from('bookings').update({ archived: true }).eq('id', id);
  if (error) throw error;
};

export const fetchSubServices = async () => {
  const { data } = await supabase.from('services').select('*').eq('is_active', true).order('sort_order');
  return data || [];
};

export const fetchShopDataForBookings = async () => {
  const [{ data: hours }, { data: hols }, { data: lbData }] = await Promise.all([
    supabase.from('shop_hours').select('*'),
    supabase.from('shop_holidays').select('*'),
    supabase.from('shop_settings').select('key,value').in('key', ['lunch_break_enabled','lunch_break_start','lunch_break_end']),
  ]);
  const lbMap = Object.fromEntries((lbData || []).map(r => [r.key, r.value]));
  return {
    shopHours: hours || [],
    holidays:  hols  || [],
    lunchBreak: { enabled: lbMap.lunch_break_enabled === 'true', start: lbMap.lunch_break_start || '12:00', end: lbMap.lunch_break_end || '13:00' },
  };
};

export const setCalendarEventId = async (bookingId, eventId) => {
  await supabase.from('bookings').update({ calendar_event_id: eventId }).eq('id', bookingId);
};

export const fetchTimeBlocks = async () => {
  const { data } = await supabase
    .from('bookings')
    .select('id, client_name, booking_date, total_duration, service_name')
    .eq('status', 'blocked')
    .eq('archived', false)
    .order('booking_date', { ascending: true });
  return data || [];
};
